import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { PageHeader } from "@/components/PageHeader";
import { Disc3, Users, Globe, Heart } from "lucide-react";

export const Route = createFileRoute("/sobre-nos")({
  head: () => ({
    meta: [
      { title: "Sobre nós — Viny Club" },
      {
        name: "description",
        content: "Conheça a Viny Club, a rede social para colecionadores de vinil.",
      },
    ],
  }),
  component: SobreNos,
});

function SobreNos() {
  return (
    <AppShell>
      <PageHeader
        eyebrow="A plataforma"
        title="Sobre nós"
        subtitle="O ritual do vinil, agora coletivo."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 lg:px-8">
        <section className="space-y-6 text-foreground/90">
          <p className="text-lg leading-relaxed">
            A <strong>Viny Club</strong> nasceu da paixão por discos e da vontade de transformar a experiência de colecionar vinil em algo social, visual e inteligente. Nosso objetivo é reunir colecionadores de todo o Brasil — e do mundo — em um único lugar onde é possível catalogar, descobrir e trocar discos com curadoria editorial.
          </p>

          <div className="grid gap-6 py-8 sm:grid-cols-2">
            <div className="rounded-2xl border border-border bg-surface p-6">
              <Disc3 className="mb-3 h-6 w-6 text-primary" />
              <h3 className="mb-1 font-display text-base font-semibold">Catálogo inteligente</h3>
              <p className="text-sm text-muted-foreground">
                Organize sua coleção com dados completos do Discogs e Spotify, capas em alta resolução e estatísticas automáticas.
              </p>
            </div>
            <div className="rounded-2xl border border-border bg-surface p-6">
              <Users className="mb-3 h-6 w-6 text-primary" />
              <h3 className="mb-1 font-display text-base font-semibold">Comunidade viva</h3>
              <p className="text-sm text-muted-foreground">
                Siga outros colecionadores, descubra o que estão ouvindo e troque recomendações em um feed exclusivo para amantes de vinil.
              </p>
            </div>
            <div className="rounded-2xl border border-border bg-surface p-6">
              <Globe className="mb-3 h-6 w-6 text-primary" />
              <h3 className="mb-1 font-display text-base font-semibold">Link Bio</h3>
              <p className="text-sm text-muted-foreground">
                Compartilhe sua coleção publicamente com um link personalizado — ideal para perfis sociais e divulgação.
              </p>
            </div>
            <div className="rounded-2xl border border-border bg-surface p-6">
              <Heart className="mb-3 h-6 w-6 text-primary" />
              <h3 className="mb-1 font-display text-base font-semibold">Feito por fãs</h3>
              <p className="text-sm text-muted-foreground">
                Cada feature foi pensada por quem realmente coleciona. Estamos construindo a plataforma que sempre quisemos usar.
              </p>
            </div>
          </div>

          <p className="text-sm text-muted-foreground">
            Viny Club é mais do que um catálogo. É um movimento para manter a cultura do vinil viva, conectada e acessível. Junte-se a nós.
          </p>
        </section>
      </div>
    </AppShell>
  );
}
